// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__28IEL","vLegacy":"SelectSecondary_vLegacy__5B6Zt","error":"SelectSecondary_error___LHVH","disabled":"SelectSecondary_disabled__1QYsT"};